/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Tabs, TabItem } from '@hb/coffee';
import { namespace } from 'vuex-class';
import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { getMyCouponList } from '@/api/coupon';
import type { CouponPo } from '@/api/coupon/types';
import { CouponStateTypeEnum } from '@/api/coupon/types';
import platform from '@/shared/utils/platform';
import type { CreditDataType } from '@/api/homeV2Status/types';
import { ubtSendError } from '@/shared/utils/ubt';
import CouponUsing from './coupon-using';
import CouponNone from './coupon-none';
import CouponSuperMember from './coupon-super-member/index.vue';

const style = require('./index.module.scss');

const HomeStore = namespace('home');

@Component({ name: 'MyCoupon' })
export default class MyCoupon extends Vue {
  @HomeStore.Action getCreditData!: () => Promise<void>;

  @HomeStore.State creditData!: CreditDataType;

  // 控制H5 NavBar 的显隐
  @InjectReactive() isShowH5Nav: boolean | undefined = undefined;

  // 可使用的优惠券
  private myValidCouponList: CouponPo[] = [];

  private ready = false;

  // 已失效的优惠券
  private myOverdueCouponList: CouponPo[] = [];

  private activeTabs = 0;

  private couponForm: {
    pageIndex: number;
    pageSize: number;
  } = {
    pageIndex: 1,
    pageSize: 1000,
  };

  private tabsList = ['可使用', '已失效'];

  /** 是否为可使用标签页 */
  private get isUsefulTab(): boolean {
    return this.activeTabs === 0;
  }

  private async created() {
    try {
      /** 如果creditData为空，则获取creditData, 考虑 null 和undefined情况 */
      if (this.creditData == null) {
        await this.getCreditData();
      }
    } catch (error) {
      ubtSendError(new Error('get credit data failed'));
    }


    // 获取我的优惠券列表（逾期和未逾期）
    const [myValidCouponList, myOverdueCouponList] = await Promise.all([
      await getMyCouponList(this.couponForm, CouponStateTypeEnum.USEFUL),
      await getMyCouponList(this.couponForm, CouponStateTypeEnum.EXPIRE),
    ]);

    this.myValidCouponList = this.couponListMap(myValidCouponList || []);
    this.myOverdueCouponList = this.couponListMap(myOverdueCouponList || []);
    this.ready = true;

    if (
      this.myOverdueCouponList.length > 0
      && this.myValidCouponList.length === 0
    ) {
      this.activeTabs = 1;
    }
  }

  private couponListMap(formArray: CouponPo[]) {
    const couponList = formArray.map((item) => ({
      ...item,
      isExtend: false,
      // 是否可选
      isSelected: false,
    }));
    return couponList;
  }

  private get getCouponStyle() {
    return this.myValidCouponList.length === 0
      && this.myOverdueCouponList.length === 0
      ? { 'background-color': '#fff' }
      : '';
  }

  // 添加数据埋点
  private onClickTab(index: number) {
    this.activeTabs = index;
    this.$ubtPageButton(
      `臻有钱_我的优惠券_${this.tabsList[index]}`,
    );
  }

  // 计算属性：当前显示的优惠券内容
  private get currentCouponContent(): CouponPo[] {
    return this.activeTabs === 0
      ? this.myValidCouponList
      : this.myOverdueCouponList;
  }

  private render() {
    return this.ready ? (
      <div
        class={
          [
            style.MyCoupon,
            this.isShowH5Nav && style.fixCoupon,
            this.isShowH5Nav && platform.isAndroid && style.androidFixCoupon,
          ]}
        style={this.getCouponStyle}
      >
        <div class={style.tab}>
          <div class={style.tabContent}>
          <Tabs
            activeIndex={this.activeTabs}
            on-click-tab={this.onClickTab}
          >
          {this.tabsList.map((item, index) => (
            <TabItem
              key={index}
              title={item}
              name={index}
            />
          ))}
          </Tabs>
        </div>
        </div>
        <div class={style.content}>
          <CouponSuperMember/>

          <div>
            {this.currentCouponContent.length > 0 ? (
              <CouponUsing
                couponList={this.currentCouponContent}
                isOverTime={this.isUsefulTab}
              />
            ) : (
              <CouponNone visible={false} />
            )}
          </div>
        </div>
      </div>
    ) : null;
  }
}
